import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {action, observable, runInAction} from 'mobx';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';

import DialogWrapper from '../../../components/dialog/Dialog';
import FormInput from '../../../components/FormHelpers/formField';
import MediaSelector from '../../../components/mediaSelector';
import {AlertType, DeviceType, LessonLibraryType} from '../../../constants/enums';
import {isMobile} from '../../../utils/screenUtility';
import {isStudent} from '../../../utils/userUtility';
import {go} from '../../../utils/navigationUtility';
import BaseButton from '../../../components/button/BaseButton';

import './styles.scss';
import '../../main/setProjectNameDialog/setProjectName.scss';

@injectIntl
@inject('dialogStore', 'appStore', 'mainStore', 'folderStore', 'dragStore')
@observer
class SetFolderNameDialog extends Component {
    @observable isSaveProcessing = false;

    @action save = async () => {
        const {folderStore, appStore, dragStore} = this.props;
        const {editedFolder, closeFolderNameDialog, addFolder, editFolder} = folderStore;
        this.isSaveProcessing = true;
        try {
            if (editedFolder.id) {
                await editFolder();
            } else {
                const folder = await addFolder();
                if (dragStore.source) {
                    dragStore.target = folder;
                    await dragStore.handleDrop();
                }
                const type = folder.shared ? LessonLibraryType.SharedLessons : LessonLibraryType.MyLessons;
                go(`/home/lesson-plans/${type}/${folder.id}`, {}, true)
            }

            closeFolderNameDialog();
        } catch (err) {
            appStore.createAlertFromMessageId(AlertType.Error, 'notifications.saveError');
            console.log(err);
        } finally {
            runInAction(() => {
                this.isSaveProcessing = false;
            });
        }
    };

    onCancel = () => {
        this.props.folderStore.closeFolderNameDialog();
    };

    onKeyUp = (e) => {
        if (e.which === 27) {
            this.onCancel();
            return;
        }
        const {name} = this.props.folderStore.editedFolder;
        if (e.which === 13 && name) this.save();
    };

    render() {
        const {dialogStore, folderStore, intl: {formatMessage: translate}} = this.props;
        const {showSetFolderNameDialog, closeSetFolderNameDialog} = dialogStore;
        const {editedFolder, editFolderName} = folderStore;
        const name = editedFolder ? editedFolder.name : '';
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'lesson-modal-root', paper: 'paper'},
            open: showSetFolderNameDialog
        };

        return (
            <DialogWrapper {...dialogProps}>
                <div className="change-project-name">
                    <button className="change-project-name-close" onClick={closeSetFolderNameDialog}>
                        <Close/>
                    </button>
                    <MediaSelector devices={[DeviceType.Desktop, DeviceType.Tablet]}>
                        <h2 className="change-project-name-heading">
                            <FormattedMessage id={editedFolder && editedFolder.id ? 'library.renameFolderForm.title' : 'library.createFolderForm.title'}/>
                        </h2>
                    </MediaSelector>
                    <MediaSelector devices={[DeviceType.Mobile]}>
                        <div className="modal-page-name">
                            <FormattedMessage id={isStudent() ? 'jams.title' : 'header.myLessons'}/>
                        </div>
                        <h2 className="change-project-name-heading">
                            <FormattedMessage id={editedFolder && editedFolder.id ? 'library.renameFolderForm.title' : 'looper.nameForm.folderMobileTitle'}/>
                        </h2>
                        {editedFolder && !editedFolder.id && <p className="change-project-name-description">
                                <FormattedMessage id='looper.nameForm.folderMobileDescription'/>
                            </p>}
                    </MediaSelector>
                    <FormInput
                        type='text'
                        name='name'
                        inputPlaceholder={translate({id: `library.createFolderForm.placeholder`})}
                        onChange={editFolderName}
                        onKeyUp={this.onKeyUp}
                        value={name}/>
                    <div className="change-project-name-actions">
                        <MediaSelector devices={[DeviceType.Desktop, DeviceType.Tablet]}>
                            <BaseButton
                                disabled={this.isSaveProcessing}
                                className="change-project-name-btn cancel"
                                label={translate({id: 'general.cancel'})}
                                type="button"
                                onClick={this.onCancel}/>
                        </MediaSelector>
                        <BaseButton
                            disabled={!name || this.isSaveProcessing}
                            className="change-project-name-btn save"
                            label={translate({id: editedFolder && editedFolder.id ? 'notations.save' : 'library.createFolderForm.create'})}
                            type="button"
                            onClick={this.save}/>
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default SetFolderNameDialog;
